module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "elevation-20 pa-0",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('page-toolbar', {
    attrs: {
      "initial-extended": false,
      "with-search": false
    },
    on: {
      "pagetoolbar:homeclicked": _vm.homeClicked
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }, [_c('template', {
    slot: "buttons-after"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.openGlobalDialog(true, 'CreateClient')
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.reload
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('template', {
    slot: "toolbar-right"
  }, [_c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "small": "",
            "icon": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("filter_list")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-subheader', {
    staticClass: "overline py-0"
  }, [_vm._v("Filter clients in space:")]), _vm._v(" "), _vm._l((_vm.spaces), function(space, index) {
    return _c('v-list-tile', {
      key: ((space.id) + "-" + index),
      on: {
        "click": function($event) {
          return _vm.addFilter(space)
        }
      }
    }, [_c('v-list-tile-avatar', [(_vm.selectedSpaceId === space.id) ? _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("check")]) : _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("radio_button_unchecked")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(space.title))])], 1)], 1)
  })], 2)], 1)], 1)], 2), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('client-list', {
    attrs: {
      "space-id": _vm.selectedSpaceId,
      "include-owned-by-me": false,
      "clear-on-select": false,
      "with-action": true,
      "with-create": false
    },
    on: {
      "relationshipselected": _vm.clientClicked,
      "update:spaceId": function($event) {
        _vm.selectedSpaceId = $event
      },
      "update:space-id": function($event) {
        _vm.selectedSpaceId = $event
      }
    }
  })], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3"
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openGlobalDialog(true, 'CreateClient')
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" New client\n      ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-sm-and-down pt-0 pl-2",
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [(_vm.selectedClient.id) ? _c('client-details', {
    on: {
      "close": _vm.homeClicked
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }) : _c('client-home', {
    on: {
      "clientClicked": _vm.clientClicked
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cd8f50e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Clients.vue
// module id = 1395
// module chunks = 9